import { call } from "redux-saga/effects";
import { API_URL, sagaFunction, ACTIONS } from "../_config";
import { CallApi } from "./api/callApi";

// export function* getSettings(action: any): any {
//   const yieldPuts = [{ type: ACTIONS.COMMON.SETTINGS }];
//   yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.SETTINGS, action.payload, true, yieldPuts);
// }

export function* getCountries(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.COUNTRIES, action.payload, true);
}

export function* getStates(action: any): any {
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.COMMON.STATES + "/" + action.payload.countryId + "/" + action.payload.type,
    null,
    true
  );
}

export function* getCities(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.CITIES + "/" + action.payload.stateId, null, true);
}

// export function* contactUs(action: any): any {
//   yield call(sagaFunction, action, CallApi.POST, API_URL.COMMON.CONTACTUS, action.payload, true);
// }

// export function* getSEOList(action: any): any {
//   const yieldPuts = [{ type: ACTIONS.COMMON.SEO_LIST }];
//   yield call(sagaFunction, action, CallApi.GET, API_URL.COMMON.SEO_LIST, action.payload, true, yieldPuts);
// }

export function* newsletterSignup(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.COMMON.NEWSLETTER_SIGNUP, action.payload, true);
}

export function* getGameStatusText(action: any): any {
  const yieldPuts = [{ type: ACTIONS.COMMON.GET_GAME_STATUS_TEXT }];
  yield call(
    sagaFunction,
    action,
    CallApi.GET,
    API_URL.COMMON.GET_GAME_STATUS_TEXT + "/" + action.payload.gameId,
    null,
    true,
    yieldPuts
  );
}
